import { render, staticRenderFns } from "./MiCuenta.vue?vue&type=template&id=6dffd39b&scoped=true&"
import script from "./MiCuenta.vue?vue&type=script&lang=js&"
export * from "./MiCuenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dffd39b",
  null
  
)

export default component.exports